import { useState, useEffect } from 'react';
import CreatePersonalFeed from './CreatePersonalFeed';
import FeedList from './FeedList';
import GatheringsSidebar from './GatheringsSidebar';

function Discussion({ currentUser }) {
  const [feedRefresh, setFeedRefresh] = useState(0);

  const handleFeedCreated = () => {
    setFeedRefresh(prev => prev + 1);
  };

  // Listen for feed refresh events (fired when clicking "Cactus #Norms")
  useEffect(() => {
    const handleRefresh = () => setFeedRefresh(prev => prev + 1);
    window.addEventListener('feedRefresh', handleRefresh);
    return () => window.removeEventListener('feedRefresh', handleRefresh);
  }, []);

  return (
    <div className="home-layout">
      {currentUser && <GatheringsSidebar currentUser={currentUser} />}
      <div className="main-content">
        {currentUser && (
          <CreatePersonalFeed
            currentUser={currentUser}
            onFeedCreated={handleFeedCreated}
          />
        )}
        {currentUser && (
          <FeedList
            currentUser={currentUser}
            refreshTrigger={feedRefresh}
          />
        )}
        {!currentUser && (
          <header className="App-header">
            <div className="feed-container">
              <img src="/images/cactus-logo.png" alt="Cactus Logo" className="feed-logo" />
              <p>Please log in to see discussions</p>
            </div>
          </header>
        )}
      </div>
    </div>
  );
}

export default Discussion;